import React, { useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import * as Models from 'disco-music-api';

import * as Auth from '../../context/auth';
import Alert from '../../components/foundation/Alert';
import Button from '../../components/foundation/Button';

import 'react-phone-number-input/style.css';
import styles from './index.module.scss';

export default function Login() {
  const [username, setUsername] = useState<string | null>(null);
  const [validationErrors, setValidationErrors] = useState<string[]>([]);

  const authContext = Auth.useAuth();
  let history = useHistory();

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (!username) {
      setValidationErrors(['Invalid phone number']);
      return;
    }

    try {
      // await authContext.login(username, 'password');
      await authContext.requestVerification(
        username,
        Models.Synthetic.Auth.VerificationMethod.SMS
      );
      history.replace(`/verify/${username}`);
    } catch (error) {
      console.error(error);
      setValidationErrors([error.message]);
      return;
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.Content}>
        <h2>Login</h2>
        <p>Welcome back.</p>

        <form onSubmit={handleSubmit}>
          {validationErrors.length ? (
            <Alert>
              <>
                {validationErrors.map((v, i) => (
                  <b key={i}>{v}</b>
                ))}
              </>
            </Alert>
          ) : null}

          <label>Username:</label>
          <input
            placeholder="Enter a username"
            type={'text'}
            value={username || ''}
            onChange={e => setUsername(e.target.value)}
            className={styles.UsernameInput}
          />

          <div className={styles.Footer}>
            <Button name={'Login'} type={'submit'} />
            <span>
              Don't have an account? <Link to={'/register'}>Register</Link>
            </span>
          </div>
        </form>
      </div>
    </div>
  );
}
